import { useEffect, useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { SUIVI_FORMULES } from "@/components/LieuSuiviFormules";

const inputCls = "w-full bg-white/60 border border-wood/25 rounded-xl px-4 py-3 text-sm focus:outline-none focus:border-terra";

export const LieuSuiviRequestForm = ({ formuleInitiale }) => {
  const [form, setForm] = useState({ nom: "", email: "", telephone: "", adresse_lieu: "", formule_suivi: "harmonisation_generale", message: "" });
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  useEffect(() => {
    if (formuleInitiale) setForm((current) => ({ ...current, formule_suivi: formuleInitiale }));
  }, [formuleInitiale]);

  const set = (key) => (event) => setForm((current) => ({ ...current, [key]: event.target.value }));
  const submit = async (event) => {
    event.preventDefault();
    setLoading(true);
    try {
      const response = await api.contact({ ...form, sujet: "Harmonisation de lieu" });
      toast.success(response.message);
      setSent(true);
    } catch {
      toast.error("La demande n’a pas pu être envoyée — réessayez ou écrivez-nous directement.");
    } finally {
      setLoading(false);
    }
  };

  if (sent) return <div className="bg-sage-light/50 border border-sage/30 rounded-2xl p-10 text-center" data-testid="lieu-suivi-success">
    <CheckCircle2 className="w-10 h-10 text-sage mx-auto mb-4" />
    <p className="font-serif text-2xl text-bark mb-2">Votre demande est bien reçue</p>
    <p className="text-sm text-fumee">Ludovic vous répondra pour convenir des modalités, du tarif final et du rendez-vous.</p>
  </div>;

  return <form id="demande-suivi" onSubmit={submit} className="space-y-5 scroll-mt-28" data-testid="lieu-suivi-form">
    <p className="font-serif text-2xl text-bark">Votre demande de suivi</p>
    <div>
      <label htmlFor="lieu-suivi-formule" className="eyebrow block mb-2">Formule souhaitée</label>
      <select id="lieu-suivi-formule" data-testid="lieu-suivi-formule" value={form.formule_suivi} onChange={set("formule_suivi")} className={inputCls}>
        {SUIVI_FORMULES.map((option) => <option key={option.id} value={option.id}>{option.label}</option>)}
      </select>
    </div>
    <div className="grid sm:grid-cols-2 gap-5">
      <div><label htmlFor="lieu-suivi-nom" className="eyebrow block mb-2">Nom complet</label><input id="lieu-suivi-nom" data-testid="lieu-suivi-nom" required value={form.nom} onChange={set("nom")} className={inputCls} /></div>
      <div><label htmlFor="lieu-suivi-email" className="eyebrow block mb-2">Courriel</label><input id="lieu-suivi-email" data-testid="lieu-suivi-email" type="email" required value={form.email} onChange={set("email")} className={inputCls} /></div>
    </div>
    <div><label htmlFor="lieu-suivi-tel" className="eyebrow block mb-2">Téléphone</label><input id="lieu-suivi-tel" data-testid="lieu-suivi-telephone" required minLength={6} value={form.telephone} onChange={set("telephone")} className={inputCls} /></div>
    <div><label htmlFor="lieu-suivi-adresse" className="eyebrow block mb-2">Lieu concerné</label><input id="lieu-suivi-adresse" data-testid="lieu-suivi-adresse" required minLength={8} value={form.adresse_lieu} onChange={set("adresse_lieu")} placeholder="Adresse, type de lieu ou localité" className={inputCls} /></div>
    <div><label htmlFor="lieu-suivi-message" className="eyebrow block mb-2">Vos besoins</label><textarea id="lieu-suivi-message" data-testid="lieu-suivi-message" required rows={5} value={form.message} onChange={set("message")} placeholder="Ce que vous souhaitez vérifier, ce qui a changé ou les besoins de votre lieu…" className={`${inputCls} resize-none`} /></div>
    <button type="submit" data-testid="lieu-suivi-submit" disabled={loading} className="min-h-12 px-8 py-3.5 rounded-full bg-earth text-sand text-sm tracking-wide hover:bg-terra hover:text-earth transition-colors duration-300 disabled:opacity-60 inline-flex items-center gap-2">
      {loading && <Loader2 className="w-4 h-4 animate-spin" />}{loading ? "Envoi…" : "Envoyer ma demande"}
    </button>
  </form>;
};